import { Link } from 'react-router-dom';
import { useAPI } from 'src/hooks';
import { useInfiniteQuery } from 'react-query';
import { useReceipt } from 'src/hooks/useReceipt';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';

const Footer = loadable(() => import('@com/footer/Footer'));
const FullSectionText = loadable(() => import('@com/FullSectionText'));
const Header = loadable(() => import('@com/header/Header'));
const LoadMoreBtn = loadable(() => import('@com/buttons/LoadMoreBtn'));
const LoadingContainer = loadable(() => import('@com/utils/LoadingContainer'));
const TopSection = loadable(() => import('@com/TopSection'));

function ReceiptPage(): JSX.Element {
  /* Define state / hook */
  const { t } = useTranslation();
  const { getAmount, getBadge, getInvoiceDate } = useReceipt();
  const { getReceiptList } = useAPI();
  const { data, isSuccess, isError, hasNextPage, fetchNextPage } =
    useInfiniteQuery<Awaited<ReturnType<typeof getReceiptList>>>(
      getReceiptList.name,
      getReceiptList,
      {
        getNextPageParam: (lastPage) => {
          return lastPage?.next_cursor;
        },
      }
    );

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Styling */

  /* Render */
  return (
    <>
      <Header />
      <TopSection sectionName={t('receipt.title')} />
      <FullSectionText>
        <LoadingContainer isError={isError} isSuccess={isSuccess}>
          <div className="table-ranking">
            <div className="item flex mb-3 h-auto" data-test="table-header">
              <h3 className="col-2">{t('receipt.action')}</h3>
              <h3 className="col-2">{t('receipt.status')}</h3>
              <h3 className="col-3">{t('receipt.paymentGateway')}</h3>
              <h3 className="col-2">{t('receipt.amount')}</h3>
              <h3 className="col-3">{t('receipt.date')}</h3>
            </div>
            {data?.pages?.map((page) =>
              page?.data?.map((item, index: number) => (
                <div key={index} className="fs-21">
                  <Link
                    className="item flex"
                    data-test="receipt-item"
                    to={`/receipt/${item?.payment_number}`}
                  >
                    <div className="col-2">
                      <span>{item?.event}</span>
                    </div>
                    <div className="col-2">{getBadge(item?.status, 'sm')}</div>
                    <div className="col-3">{item?.payment_gateway?.name}</div>
                    <div className="col-2">
                      {getAmount(item?.amount, item?.currency)}
                    </div>
                    <div className="col-3">
                      {getInvoiceDate(
                        item?.paid_at_timestamp || item?.created_at_timestamp
                      )}
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
          <LoadMoreBtn
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
          />
        </LoadingContainer>
      </FullSectionText>
      <Footer />
    </>
  );
}

export default ReceiptPage;
